/**
 * TMPendingPage — shown while awaiting admin approval
 */
import { Clock } from 'lucide-react';
import { signOut } from 'firebase/auth';
import { auth } from '@/config/firebase';
import { useNavigate } from 'react-router-dom';

export default function TMPendingPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex flex-col items-center justify-center p-6 text-center">
      <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-4">
        <Clock className="h-8 w-8 text-amber-500" />
      </div>
      <h1 className="text-xl font-bold text-gray-900 mb-2">Awaiting Approval</h1>
      <p className="text-sm text-gray-500 max-w-xs mb-6">
        Your request has been submitted. An admin will review and approve your account shortly.
        You'll be able to sign in once approved.
      </p>
      <button
        onClick={async () => { await signOut(auth); navigate('/tm'); }}
        className="text-sm text-indigo-600 font-medium hover:underline"
      >
        Sign out
      </button>
    </div>
  );
}
